import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicPagesViewPageRoutingModule } from './dynamic-pages-view-routing.module';
import { DynamicPagesViewPage } from './dynamic-pages-view.component';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { HeaderPageTitleBoxComponent } from '@components/headers/page-title-box/page-title-box.component';
import { PlaceholderCardFormVerticalComponent } from '@components/placeholders/card-form-vertical/card-form-vertical.component';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from 'primeng/editor';
import { InputTextModule } from 'primeng/inputtext';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { PreviewUploadImageComponent } from '@components/preview-upload-image/preview-upload-image.component';
import { ChipsModule } from 'primeng/chips';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ShowForPermissionsDirective } from '@directives/show-for-permissions.directive';

@NgModule({
  declarations: [
    DynamicPagesViewPage
  ],
  imports: [
    CommonModule,
    DynamicPagesViewPageRoutingModule,
    BackboneComponent,
    HeaderPageTitleBoxComponent,
    PlaceholderCardFormVerticalComponent,
    ReactiveFormsModule,
    RouterModule,
    InputTextModule,
    ButtonModule,
    EditorModule,
    NgSelectModule,
    PreviewUploadImageComponent,
    ChipsModule,
    FormsModule,
    InputTextareaModule,
    ShowForPermissionsDirective
  ]
})
export class DynamicPagesViewPageModule { }
